import { getLocalStorageData } from '../../utils/helper';
import { APP_API_URL_V2 } from '../../utils/xhr-instance';
import { axiosInstanceV2 } from '../axios';

export async function createInvoice(data) {
	const API_URL = `${APP_API_URL_V2}/sales/invoices`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.post(API_URL, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => {
			return res.data;
		})
		.catch((err) => {
			return err?.response?.data;
		});
}

export async function updateInvoice(id, data, authToken) {
	const API_URL = `${APP_API_URL_V2}/sales/invoices/${id}`;
	const token = getLocalStorageData();

	return await axiosInstanceV2
		.put(API_URL, data, {
			headers:
				authToken !== ''
					? {
							'Content-Type': 'application/json',
							Authorization: `Bearer ${token?.token}`,
							'x-invoice-edit-token': authToken,
						}
					: {
							'Content-Type': 'application/json',
							Authorization: `Bearer ${token?.token}`,
						},
		})
		.then((res) => res.data)
		.catch((err) => err?.response?.data || 'Something went wrong');
}

export async function deleteInvoice(data) {
	const API_URL = `${APP_API_URL_V2}/sales/invoice`;
	const token = getLocalStorageData();
	try {
		await axiosInstanceV2.delete(API_URL, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
			data: data,
		});
	} catch (error) {
		throw error?.response?.data;
	}
}

export async function getInvoiceDetail(id) {
	const token = getLocalStorageData();
	try {
		const res = await axiosInstanceV2.get(`${APP_API_URL_V2}/sales/invoices/${id}`, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		});
		return res.data.data;
	} catch (error) {
		throw error?.response?.data;
	}
}
export async function fetchInvoiceNumber() {
	const token = getLocalStorageData();
	try {
		const { data } = await axiosInstanceV2.get(`${APP_API_URL_V2}/sales/invoices/number`, {
			headers: {
				Authorization: `Bearer ${token?.token}`,
			},
		});
		return data.data.invoice;
	} catch (error) {
		throw error?.response?.data;
	}
}
export async function sendEmail(id, data) {
	const token = getLocalStorageData();
	try {
		const { res } = await axiosInstanceV2.post(
			`${APP_API_URL_V2}/sales/invoices/${id}/send/email`,
			data,
			{
				headers: {
					Authorization: `Bearer ${token?.token}`,
				},
			},
		);
		return res;
	} catch (error) {
		throw error?.response?.data;
	}
}
export async function getInvoicesList(data) {
	const token = getLocalStorageData();
	try {
		const res = await axiosInstanceV2.post(`${APP_API_URL_V2}/sales/invoices/list`, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		});
		return res.data.data;
	} catch (error) {
		throw error?.response?.data;
	}
}
export async function getSummary() {
	const token = getLocalStorageData();
	try {
		const res = await axiosInstanceV2.get(`${APP_API_URL_V2}/sales/invoices/summary`, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		});
		return res.data.data;
	} catch (error) {
		throw error?.response?.data;
	}
}
export async function fetchInvoiceDetails(data) {
	const token = getLocalStorageData();
	try {
		const res = await axiosInstanceV2.post(`${APP_API_URL_V2}/sales/invoices/details`, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		});
		return res.data.data;
	} catch (error) {
		throw error?.response?.data;
	}
}
export async function updateInvoiceBulkStatus(data) {
	const token = getLocalStorageData();
	try {
		const res = await axiosInstanceV2.post(
			`${APP_API_URL_V2}/sales/invoices/update/status/bulk`,
			data,
			{
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${token?.token}`,
				},
			},
		);
		return res.data.data;
	} catch (error) {
		throw error?.response?.data;
	}
}
export async function generateInvoiceSharedLink(data) {
	const token = getLocalStorageData();
	try {
		const res = await axiosInstanceV2.post(
			`${APP_API_URL_V2}/sales/invoices/documents/share/`,
			data,
			{
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${token?.token}`,
				},
			},
		);
		return res.data.data;
	} catch (error) {
		throw error?.response?.data;
	}
}
export async function createInvoiceSharedLink(id) {
	const token = getLocalStorageData();
	try {
		const res = await axiosInstanceV2.get(
			`${APP_API_URL_V2}/sales/invoices/documents/share/${id}`,
			{
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${token?.token}`,
				},
			},
		);
		return res.data;
	} catch (error) {
		throw error?.response?.data;
	}
}

export async function updateInvoiceStatus(id, status) {
	const API_URL = `${APP_API_URL_V2}/sales/invoices/${id}?status=${status}`;
	const token = getLocalStorageData();
	try {
		const res = await axiosInstanceV2.patch(
			API_URL,
			{},
			{
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${token?.token}`,
				},
			},
		);
	} catch (error) {
		throw error?.response?.data;
	}
}

export async function generateSalesInvoicesPdf(id, merge = false) {
	try {
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstanceV2.get(
			`${APP_API_URL_V2}/sales/invoices/generate-pdf?ids=${id}&merge=${merge}`,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return data?.data.signed_urls[0];
	} catch (error) {
		throw new Error(error?.response?.data?.message);
	}
}
